import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";

import { myGlobals, myUtilities } from "../../Utils";
import { store as reduxStore } from "../../redux/store";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { alertAlertAtion } from "../../redux/actions/alertAction";

import { callReduxAlertAction, globalVars, callReduxAlertActionWithParameter} from "../../App";
import { PaymentCard, PaymentGroup, TncBox } from "./";
import AlertDropdown from "../Common/AlertDropdown";
import StaticLoader from "../Common/StaticLoader";
import ACHTransfer from "../../Images/ACHTransfer.svg";
import CreditCard from "../../Images/CreditCardIcon.svg";
import Bancontact from "../../Images/bancontact.svg";
import PayPal from "../../Images/paypal.svg"
import GiroPay from "../../Images/Giropay.svg";
import Ideal from "../../Images/ideal.svg";
import Trustly from "../../Images/Trustly.svg";
class PaymentSelectionCardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTermsAndConditions: false,
      method: "ACH",
      htmlModal: false,
      modalClose: false,
    };
    this.myref = React.createRef();
  }

  onDiscountSuccess = (data, invData, paymentData) => {
    if (data != undefined) {
      let isPOA = invData.state.paymentOnAccount;
      let lateFee = data.rows.totalLateFee !== null ? data.rows.totalLateFee : 0;
      let discountValue = parseFloat(data.rows.discount);
      console.log(discountValue);
      let totalAmt = invData.getTotalInvoiceAmount(
        invData.state.selectedInvoices
      );
      console.log(totalAmt);
      console.log("Is POA -> " + isPOA);
      if (!isPOA) {
        totalAmt = parseFloat(totalAmt) + parseFloat(lateFee) - parseFloat(discountValue);
      } else {
        totalAmt = parseFloat(totalAmt) - parseFloat(discountValue);
      }
      if (paymentData.state.totalConvienceFee !== null) {
        totalAmt =
          parseFloat(totalAmt) +
          parseFloat(paymentData.state.totalConvienceFee);
      }
      if (paymentData.state.totalSurchargeAmount !== null) {
        totalAmt =
          parseFloat(totalAmt) +
          parseFloat(paymentData.state.totalSurchargeAmount);
      }
      totalAmt = totalAmt.toFixed(2);
      console.log(totalAmt);
      invData.setState({
        totalDiscVal: discountValue,
        total: totalAmt,
      });
    }
  };
  addDiscBasedOnPmtMethod = (
    invData,
    paymentMethod,
    paymentData,
    showAlertDialog
  ) => {
    if (myGlobals.isDiscountEnabled || (invData.state.isLateFeeEnabled && !invData.state.paymentOnAccount)) {
    	
      if (globalVars.selectedCard === 1 || globalVars.selectedCard === 0) { // ach or cc
    		if( !((globalVars.isTermsSelected && invData.state.showPaymentContracts) ||
    				!invData.state.showPaymentContracts)) {
    			return;
    		}
      }
    	
      let token = invData.state.token;
      const searchParams = new URLSearchParams();
      searchParams.append("token", token);
      let invoiceNumbers = "";
      let partialPaymentAmounts = "";
      invData.state.selectedInvoices.forEach((invoice) => {
        invoiceNumbers += invoice.accountDocHeaderId + ",";
        const originalAmount = parseFloat(invoice.payableAmount2 !== undefined ? invoice.payableAmount2 : invoice.payableAmount);
        const currentAmount = parseFloat(invoice.payableAmount);
        if (!Number.isNaN(currentAmount) && !Number.isNaN(originalAmount) && currentAmount > 0 && currentAmount < originalAmount) {
          partialPaymentAmounts += invoice.accountDocHeaderId + ":" + currentAmount + ",";
        }
      });
      invoiceNumbers = invoiceNumbers.substring(0, invoiceNumbers.length - 1);
      if (partialPaymentAmounts.length > 0) {
        partialPaymentAmounts = partialPaymentAmounts.substring(0, partialPaymentAmounts.length - 1);
      }
      searchParams.append("invoiceNumbers", invoiceNumbers);
      searchParams.append("partialPaymentAmounts", partialPaymentAmounts);
      console.log(paymentMethod);
      searchParams.append("paymentMethod", paymentMethod);
      let link = "getPmtMethodBasedDiscount";
      link = myGlobals.initialHost + myGlobals.appender + link;
      fetch(link, {
        //"https://gist.githubusercontent.com/gokuafrica/53a8cf6f81f9eca632dfa241a148378b/raw/d9de7b9c47d12f551c015aa8dc81742478c680d0/test"
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            throw new Error("Status: " + response.status);
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data != null && data.rows != null) {
            let discount = parseFloat(data.rows.discount);
            if (isNaN(discount)) {
              data.rows.discount = this.state.totalDiscVal;
            }
            let totalLateFee = parseFloat(data.rows.totalLateFee);
            
            if (isNaN(totalLateFee)) {
              data.rows.totalLateFee = 0;
            }

            // setting totalLateFee in paymentData state
            paymentData.state.totalLateFee = data.rows.totalLateFee;

            this.onDiscountSuccess(data, invData, paymentData);
          }
        })
        .catch(function (err) {
          console.log("Fetch Error for discounts:-S", err);
          showAlertDialog();
        });
    }
  };
  showDiscountAlert = () => {
    reduxStore.dispatch(
      alertAlertAtion({
        message: "Fetching discount based on payment method failed",
        id: "failure.generic.discount.alert",
        additionalItems : []
      })
    );
  };
  onClickCCorDC = (paymentData, invdata) => {
    if (myGlobals.paymentMethod === "CREDITCARD") {
      paymentData.isDCFlow(false);
      myGlobals.isACHFlow = false;
      this.props.setSelectedMethod("loading");
      paymentData.setCreditCardCheck(true);
      globalVars.showTermsAndConditions(false);
      globalVars.isTermsSelected = !globalVars.isTermsSelected;
      globalVars.selectedCard = -1;
      globalVars.paymentCardKeyCount = new Set();
    } else if (myGlobals.paymentMethod === "DEBITCARD") {
      paymentData.isDCFlow(true);
      myGlobals.isACHFlow = false;
      myGlobals.selectedStateMethodPaymentContainer("loading");
      paymentData.setCreditCardCheck(true);
      globalVars.selectedCard = -1;
      globalVars.paymentCardKeyCount = new Set();
    }
  };
  onClick = (paymentData, invData) => {
    let ua = window.navigator.userAgent;
    let trident = ua.indexOf("Trident/");
    if (globalVars.selectedCard === -1) {
      callReduxAlertAction(
        "Selection.Mandate.Alert",
        "Please select a payment method before proceeding"
      );
    } else {
      let paymentMethod;
      if (
        globalVars.selectedCard === 0 &&
        ((globalVars.isTermsSelected && invData.state.showPaymentContracts) ||
          !invData.state.showPaymentContracts ||
          (!globalVars.isTermsSelected && invData.state.achAgreementType == ""))
      ) {
        myGlobals.selectedStateMethodPaymentContainer("ACH");
        paymentData.populateInputData("accountType", invData.state.defaultAchAccountType);
        paymentMethod = "ACH";
        let totalAmt = invData.getTotalInvoiceAmount(
          invData.state.selectedInvoices
        );
        invData.setState({
          total: totalAmt,
        });
        paymentData.setTotalConvenienceFeeAndSurcharge(null, null);
        globalVars.showTermsAndConditions(false);
        globalVars.isTermsSelected = !globalVars.isTermsSelected;
        globalVars.selectedCard = -1;
        globalVars.paymentCardKeyCount = new Set();
      } else if (
        globalVars.selectedCard === 1 &&
        ((globalVars.isTermsSelected && invData.state.showPaymentContracts) ||
          !invData.state.showPaymentContracts ||
          (!globalVars.isTermsSelected && invData.state.ccAgreementType == ""))
      ) {

    	  if (myUtilities.checkTransactionLimit("CREDITCARD", invData) === -1) 
           return;
        paymentMethod = "CREDITCARD";
        myGlobals.paymentMethod = "CREDITCARD";

        if(invData.state.CC_routingBasedOnPaymentInstrument)
            invData.makeDropdownCallForCardTypes(paymentMethod);
        else
          this.onClickCCorDC(paymentData)

      } else if (globalVars.selectedCard === 2) {
        myGlobals.selectedStateMethodPaymentContainer("TRUSTLY");
        paymentMethod = "TRUSTLY";
        globalVars.selectedCard = -1;
        globalVars.paymentCardKeyCount = new Set();
      } else if (globalVars.selectedCard === 3) {
        myGlobals.selectedStateMethodPaymentContainer("GIROPAY");
        paymentMethod = "GIROPAY";
        globalVars.selectedCard = -1;
        globalVars.paymentCardKeyCount = new Set();
      } else if (globalVars.selectedCard === 4) {
        myGlobals.selectedStateMethodPaymentContainer("IDEAL");
        paymentMethod = "IDEAL";
        globalVars.selectedCard = -1;
        globalVars.paymentCardKeyCount = new Set();
      } else if (globalVars.selectedCard === 5) {
        myGlobals.selectedStateMethodPaymentContainer("BANCONTACT");
        paymentMethod = "BANCONTACT";
        globalVars.selectedCard = -1;
        globalVars.paymentCardKeyCount = new Set();
      } else if (globalVars.selectedCard === 6) {
        myGlobals.selectedStateMethodPaymentContainer("PAYPAL");
        paymentMethod = "PAYPAL";
        globalVars.selectedCard = -1;
        globalVars.paymentCardKeyCount = new Set();
      } else if (globalVars.selectedCard === 7 && 
              ((globalVars.isTermsSelected && invData.state.showPaymentContracts) ||
              !invData.state.showPaymentContracts ||
              (!globalVars.isTermsSelected && invData.state.dcAgreementType == ""))) {
    	   
         if (myUtilities.checkTransactionLimit("DEBITCARD", invData) === -1) 
                return;
          paymentMethod = "DEBITCARD";
          myGlobals.paymentMethod = "DEBITCARD";
          if(invData.state.DC_routingBasedOnPaymentInstrument)
            invData.makeDropdownCallForCardTypes(paymentMethod);
          else
            this.onClickCCorDC(paymentData)
      } else if (
        (globalVars.selectedCard === 0 || globalVars.selectedCard === 1) &&
        trident > 0
      )
        callReduxAlertAction(
          "Terms.Mandate.Alert",
          "Please accept the terms and conditions"
        );

      if (paymentMethod !== undefined && invData.state.partialPaymentEnabledForGuestPay) {
        invData.setState({ partialPayProceeded: true });
      }

      this.addDiscBasedOnPmtMethod(
        invData,
        paymentMethod,
        paymentData,
        this.showDiscountAlert
      );
    }
  };

  showAdditionalMethods = (invdata) => {
    if (invdata.state.showAdditionalMethods)
      return (
        <PaymentGroup
          centerContainer={!invdata.state.showFrequentMethods}
          seperatorText={
            myUtilities.accountSpecificLanguage(
              "card.others.seperator",
              "Other Payment Methods"
            )
          }
        >
          {this.checkPaymentMethodEnabled(
            invdata,
            "trustlyEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={2}
	          text={myUtilities.accountSpecificLanguage("paymentmethods.Trustly","Trustly") }
              img={
                Trustly
              }
            />
          )}
          {this.checkPaymentMethodEnabled(
            invdata,
            "giropayEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={3}
	            text={myUtilities.accountSpecificLanguage("paymentmethods.GiroPay","Giro Pay")}
              img={
                GiroPay
              }
            />
          )}
          {this.checkPaymentMethodEnabled(
            invdata,
            "idealEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={4}
	            text={myUtilities.accountSpecificLanguage("paymentmethods.iDeal","iDeal")}
              img={
                Ideal
              }
            />
          )}
          {this.checkPaymentMethodEnabled(
            invdata,
            "bancontactEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={5}
	            text={myUtilities.accountSpecificLanguage("paymentmethods.Bancontact","Bancontact")}
              img={
                Bancontact
              }
            />
          )}
          {this.checkPaymentMethodEnabled(
            invdata,
            "paypalEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={6}
	            text={myUtilities.accountSpecificLanguage("paymentmethods.Paypal","Paypal")}
              img={
                PayPal
              }
            />
          )}
        </PaymentGroup>
      );
  };

  checkPaymentMethodEnabled = (invdata, flag, comp) => {
    if (invdata.state[flag]) return comp;
  };

  showFrequentMethods = (invdata) => {
    if (invdata.state.showFrequentMethods)
      return (
        <PaymentGroup
          centerContainer={!invdata.state.showAdditionalMethods}
          seperatorText={
            myUtilities.accountSpecificLanguage(
              "card.frequent.seperator"
              ,"Frequent Payment Methods")}
        >
          {this.checkPaymentMethodEnabled(
            invdata,
            "isAchEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={0}
              text={
                myUtilities.accountSpecificLanguage("paymentmethods.ach"
                  ,"Bank Account")
              }
              img={
                ACHTransfer
              }
            />
          )}
          {this.checkPaymentMethodEnabled(
            invdata,
            "isCCEnabled",
            <PaymentCard
              showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
              identifier={1}
              text={myUtilities.accountSpecificLanguage("paymentmethods.creditcard","Credit Card")}
              img={
                CreditCard
              }
            />
          )}
          {this.checkPaymentMethodEnabled(
                  invdata,
                  "isDCEnabled",
                  <PaymentCard
                    showTermsAndConditions={this.toggleTermsAndConditionsCheckbox}
                    identifier={7}
                    text={myUtilities.accountSpecificLanguage("paymentmethods.debitCard","Debit Card")}
                    img={
                     CreditCard
                    }
                  />
           )}
        </PaymentGroup>
      );
  };

  showValidationMessage = () =>
    globalVars.isTermsSelected
      ? ""
      : myUtilities.accountSpecificLanguage(
           "form.validation.error",
           "Please fill out this field."
        );

  showTermsAndConditions = (invData) => {
    if (this.state.showTermsAndConditions) {
      let fileName;
      let token;
      if (this.state.method.localeCompare("ACH") === 0) {
        if (invData.state.achAgreementType.localeCompare("staticLink") === 0) {
          return (
            <Row>
              <div className="terms-and-conditions">
                <div>
                  <form
                    action="javascript:void(0);"
                    id="terms-and-conditions-form"
                  >
                  <div id="checkboxTnc" class="checkboxOne">
                    <input
                      ref={this.myref}
                      title={this.showValidationMessage()}
                      onInvalid={() =>
                        this.myref.current.setCustomValidity(
                          myUtilities.accountSpecificLanguage(
                             "form.validation.error",
                             "Please fill out this field."
                          )
                        )
                      }
                      type="checkbox"
                      required
                      id="myGlitchedCheckbox"
                      onChange={() =>
                        (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                      }
                    /><label for="myGlitchedCheckbox"></label>
                    </div>
                  </form>{" "}
                  <label className="payment-tnc-label">
                  {myUtilities.accountSpecificLanguage(
                    "Terms.IAccept"
                    ,"I accept the")}
                    <a
                      href
                      onClick={() =>
                        window.open(invData.state.ACHAgreementpath, "_blank")
                      }
                    >
                      {myUtilities.accountSpecificLanguage(
                        "Terms.TermsAndConditions"
                        ,"Terms and Conditions")}
                    </a>
                  </label>
                  <br />
                </div>
              </div>
            </Row>
          );
        } else if (invData.state.achAgreementType.localeCompare("html") === 0) {
          return (
            <Row>
              <div className="terms-and-conditions">
                <div>
                  <form
                    action="javascript:void(0);"
                    id="terms-and-conditions-form"
                  > 
                  <div id="checkboxTnc" class="checkboxOne">
                    <input
                      ref={this.myref}
                      title={this.showValidationMessage()}
                      onInvalid={() =>
                        this.myref.current.setCustomValidity(
                          myUtilities.accountSpecificLanguage(
                            "form.validation.error",
                            "Please fill out this field."
                          )
                        )
                      }
                      type="checkbox"
                      required
                      id="myGlitchedCheckbox"
                      onChange={() =>
                        (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                      }
                    /><label for="myGlitchedCheckbox"></label>
                    </div>
                  </form>{" "}
                  <label className="payment-tnc-label">
                  {myUtilities.accountSpecificLanguage("Terms.IAccept"
                      ,"I accept the")}
                    <a href onClick={() => this.showTAndCHtml()}>
                    {myUtilities.accountSpecificLanguage(
                      "Terms.TermsAndConditions",
                      "Terms and Conditions")}
                    </a>
                  </label>
                  <br />
                </div>
              </div>
            </Row>
          );
        } else if (
          invData.state.achAgreementType.localeCompare("s3Path") === 0
        ) {
          token = myGlobals.token;
          fileName = invData.state.ACHAgreementpath;
          fileName = fileName.trim();
          fileName =
            "/radiusoneweb/securedFileDownload?file=" +
            fileName +
            "&token=" +
            encodeURIComponent(token) +
            "&src=TC";
          return (
            <Row>
              <div className="terms-and-conditions">
                <div>
                  <form
                    action="javascript:void(0);"
                    id="terms-and-conditions-form"
                  ><div id="checkboxTnc" class="checkboxOne">
                    <input
                      ref={this.myref}
                      title={this.showValidationMessage()}
                      onInvalid={() =>
                        this.myref.current.setCustomValidity(
                          myGlobals.injectProp.formatMessage({
                            id: "form.validation.error",
                            defaultMessage: "Please fill out this field.",
                          })
                        )
                      }
                      type="checkbox"
                      required
                      id="myGlitchedCheckbox"
                      onChange={() =>
                        (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                      }
                    /><label for="myGlitchedCheckbox"></label>
                    </div>
                  </form>{" "}
                  <label className="payment-tnc-label">
                  {myUtilities.accountSpecificLanguage(
                      "Terms.IAccept",
                      "I accept the"
                    )}
                    <a href onClick={() => window.open(fileName)}>
                    {myUtilities.accountSpecificLanguage(
                        "Terms.TermsAndConditions",
                        "Terms and Conditions"
                    )}
                    </a>
                  </label>
                  <br />
                </div>
              </div>
            </Row>
          );
        } else {
          return (
            <Row>
              <div className="terms-and-conditions"></div>
            </Row>
          );
        }
      } else if (this.state.method.localeCompare("CC") === 0) {
        if (invData.state.ccAgreementType.localeCompare("staticLink") === 0) {
          return (
            <Row>
              <div className="terms-and-conditions">
                <div>
                  <form
                    action="javascript:void(0);"
                    id="terms-and-conditions-form"
                  >
                  <div id="checkboxTnc" class="checkboxOne">
                    <input
                      ref={this.myref}
                      title={this.showValidationMessage()}
                      onInvalid={() =>
                        this.myref.current.setCustomValidity(
                          myUtilities.accountSpecificLanguage(
                             "form.validation.error",
                             "Please fill out this field."
                          )
                        )
                      }
                      type="checkbox"
                      required
                      id="myGlitchedCheckbox"
                      onChange={() =>
                        (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                      }
                    /> <label for="myGlitchedCheckbox"></label>
                    </div>
                  </form>{" "}
                  <label className="payment-tnc-label">
                    {myUtilities.accountSpecificLanguage(
                      "Terms.IAccept",
                      "I accept the"
                    )}
                    <a
                      href
                      onClick={() =>
                        window.open(invData.state.CCAgreementpath, "_blank")
                      }
                    >
                      {myUtilities.accountSpecificLanguage(
                        "Terms.TermsAndConditions",
                        "Terms and Conditions"
                      )}
                    </a>
                  </label>
                  <br />
                </div>
              </div>
            </Row>
          );
        } else if (invData.state.ccAgreementType.localeCompare("html") === 0) {
          return (
            <Row>
              <div className="terms-and-conditions">
                <div>
                  <form
                    action="javascript:void(0);"
                    id="terms-and-conditions-form"
                  >
                  <div id="checkboxTnc" class="checkboxOne">
                    <input
                      ref={this.myref}
                      title={this.showValidationMessage()}
                      onInvalid={() =>
                        this.myref.current.setCustomValidity(
                          myUtilities.accountSpecificLanguage(
                            "form.validation.error",
                             "Please fill out this field."
                          )
                        )
                      }
                      type="checkbox"
                      required
                      id="myGlitchedCheckbox"
                      onChange={() =>
                        (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                      }
                    /><label for="myGlitchedCheckbox"></label>
                    </div>
                  </form>{" "}
                  <label className="payment-tnc-label">
                    {myUtilities.accountSpecificLanguage(
                      "Terms.IAccept",
                      "I accept the")}
                    <a href onClick={() => this.showTAndCHtml()}>
                    {myUtilities.accountSpecificLanguage(
                        "Terms.TermsAndConditions",
                        "Terms and Conditions"
                    )}
                    </a>
                  </label>
                  <br />
                </div>
              </div>
            </Row>
          );
        } else if (
          invData.state.ccAgreementType.localeCompare("s3Path") === 0
        ) {
          fileName = invData.state.CCAgreementpath;
          if (invData.state.token) token = invData.state.token;
          else
            token = window.location.search.substring(
              7,
              window.location.search.length
            );
          fileName = fileName.trim();
          fileName =
            "/radiusoneweb/securedFileDownload?file=" +
            fileName +
            "&token=" +
            encodeURIComponent(token) +
            "&src=TC";
          return (
            <Row>
              <div className="terms-and-conditions">
                <div>
                  <form
                    action="javascript:void(0);"
                    id="terms-and-conditions-form"
                  >
                  <div id="checkboxTnc" class="checkboxOne">
                    <input
                      ref={this.myref}
                      title={this.showValidationMessage()}
                      onInvalid={() =>
                        this.myref.current.setCustomValidity(
                          myUtilities.accountSpecificLanguage(
                            "form.validation.error",
                            "Please fill out this field."
                          )
                        )
                      }
                      type="checkbox"
                      required
                      id="myGlitchedCheckbox"
                      onChange={() =>
                        (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                      }
                    /> <label for="myGlitchedCheckbox"></label>
                    </div>
                  </form>{" "}
                  <label className="payment-tnc-label">
                  {myUtilities.accountSpecificLanguage(
                      "Terms.IAccept",
                      "I accept the")}
                    <a href onClick={() => window.open(fileName)}>
                    {myUtilities.accountSpecificLanguage(
                        "Terms.TermsAndConditions",
                        "Terms and Conditions")}
                    </a>
                  </label>
                  <br />
                </div>
              </div>
            </Row>
          );
        } else {
          return (
            <Row>
              <div className="terms-and-conditions"></div>
            </Row>
          );
        }
      } else if (this.state.method.localeCompare("DC") === 0)
          return (
                  <TncBox
                    payMethod={this.state.method}
                    invData={invData}
                    showTAndCHtml={this.showTAndCHtml}
                    reference = {this.myref}
                  />
       );
    }
  };

  showTAndCHtml = () => {
    this.setState({
      htmlModal: true,
      modalClose: false,
    });
  };

  handleModalClose = () => {
    this.setState({
      modalClose: true,
    });
  };

  showHtmlModal = (invData) => {
    if (this.state.htmlModal && !this.state.modalClose) {
      if (this.state.method.localeCompare("ACH") === 0) {
        return (
          <Modal show={this.state.htmlModal} centered>
            <Modal.Body className="payment-tnc-modal">
              {/* {myUtilities.accountSpecificLanguage("paymentmethods.alldisabled", "All payment methods disabled, please contact admin for further details"/> */}
              <td
                dangerouslySetInnerHTML={{
                  __html: invData.state.ACHAgreementpath,
                }}
              />
              {/* {invData.state.ACHAgreementpath}; */}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleModalClose}>
              {myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}
              </Button>
            </Modal.Footer>
          </Modal>
        );
      } else if (this.state.method.localeCompare("CC") === 0) {
        return (
          <Modal show={this.state.htmlModal} centered>
            <Modal.Body className="payment-tnc-modal">
              {/* {myUtilities.accountSpecificLanguage("paymentmethods.alldisabled", "All payment methods disabled, please contact admin for further details"/> */}
              <td
                dangerouslySetInnerHTML={{
                  __html: invData.state.CCAgreementpath,
                }}
              />
              {/* {invData.state.ACHAgreementpath}; */}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleModalClose}>
              {myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}
              </Button>
            </Modal.Footer>
          </Modal>
        );
      } else if (this.state.method.localeCompare("DC") === 0) {
          return (
                  <Modal show={this.state.htmlModal} centered>
                    <Modal.Body className="payment-tnc-modal">
                      <td
                        dangerouslySetInnerHTML={{
                          __html: invData.state.DCAgreementpath,
                        }}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={this.handleModalClose}>
                        {myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                );
        }
    }
  };

  toggleTermsAndConditionsCheckbox = (bool, method = "ACH") => {
    this.setState({
      showTermsAndConditions: bool,
      method: method,
    });
  };

  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invdata) => (
              <Container className="payment-selection-container relative center-element">
                <div className="payment-Methods-div">
                  {this.showFrequentMethods(invdata)}
                  {this.showAdditionalMethods(invdata)}
                </div>
                <Row className="payment-proceed-div">
                  <Col className="proceed-container">
                    <button
                      type="submit"
                      form="terms-and-conditions-form"
                      className="proceed-button mainapp-button"
                      onClick={() => {
                        this.onClick(data, invdata);
                      }}
                    >
                      {myUtilities.accountSpecificLanguage(
                        "proceed",
                        "Proceed"
                      )}
                    </button>
                  </Col>
                </Row>
                {this.showTermsAndConditions(invdata)}
                {this.showHtmlModal(invdata)}
                {invdata.state.showStaticLoading &&  <StaticLoader/> }
                <AlertDropdown
                  invData={invdata}
                  paymentData={data}
                  onClickConfirm={this.onClickCCorDC}
                />
              </Container>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }

  componentDidMount = () => {
    // showTermsAndConditions = this.toggleTermsAndConditionsCheckbox;
  };
}

export default PaymentSelectionCardView;
